import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "div-contrato" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "col-md-12 d-print-none" }

import { defineComponent, onMounted, reactive } from "vue";
  import { useRoute, useRouter } from 'vue-router';

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as service from "@/services/clientesContratosService";
  import { corrigirImagensContrato } from "@/utils/funcoes";

  //componentes
  import ReportView from "@/components/ReportView/Index.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Ver',
  setup(__props) {

  const route = useRoute();
  const router = useRouter();

  var controle = reactive({
    filtros: {
      paginaAtual: 1,
      tamanhoPagina: 1
    } as unknown as service.Filtros,
    model: {} as service.Contrato,


    status: "",
    erro: "",
  })

  onMounted(async ()=>{
    pesquisar();
  })

  async function pesquisar() {

    if (route.params.id) {
      controle.filtros.contratoId = parseInt(route.params.id as string);
    }

    service.obterPorId(controle.filtros.contratoId)
    .then(r=> {
      controle.model = r;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

function imprimir() {
  window.print();
}


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Contratos",
      items: [ 
      { label: 'Contratos', to: '/contatos' } ]
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "contrato",
        innerHTML: _unref(corrigirImagensContrato)(_unref(controle).model.texto)
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn-primary btn-sm me-2",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1),
        _createTextVNode(" Voltar ", -1)
      ]))]),
      _createElementVNode("button", {
        class: "btn btn-secondary btn-sm",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (imprimir()))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("i", { class: "flaticon-printer" }, null, -1),
        _createTextVNode(" Imprimir ", -1)
      ]))]),
      _createVNode(_component_RouterLink, {
        class: "btn btn-primary btn-sm float-end",
        to: "/"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createElementVNode("i", { class: "fa fa-times" }, null, -1),
          _createTextVNode(" Fechar ", -1)
        ]))]),
        _: 1
      })
    ])
  ], 64))
}
}

})